import type { CreateAccountException } from "@freightsimple/generated-dashboard-openapi-client/models/CreateAccountException";

export class CreateAccountError extends Error {
  data: CreateAccountException;
  constructor(data: CreateAccountException) {
    super(JSON.stringify(data));
    this.data = data;
    this.name = "CreateAccountError";
  }
}
